export default "__VITE_ASSET__CeGqAVgP__"